export const generalPaths = {
  paymentSources: '/my/payment_sources',
  ESpaymentSources: '/es/my/payment_sources',
  purchaseDetails: '/purchase_details',
  ESpurchaseDetails: '/es/purchase_details',
  myAccount: '/my/account'
};

const allScreensPaths = {
  ...generalPaths
};

export const screenNames = {
  paymentSources: 'paymentSources',
  ESpaymentSources: 'ESpaymentSources',
  purchaseDetails: 'purchaseDetails',
  ESpurchaseDetails: 'ESpurchaseDetails',
  myAccount: 'myAccount'
};

const generalRoutes = {
  [screenNames.paymentSources]: {
    path: allScreensPaths.paymentSources
  },
  [screenNames.ESpaymentSources]: {
    path: allScreensPaths.ESpaymentSources
  },
  [screenNames.purchaseDetails]: {
    path: allScreensPaths.purchaseDetails
  },
  [screenNames.ESpurchaseDetails]: {
    path: allScreensPaths.ESpurchaseDetails
  },
  [screenNames.myAccount]: {
    path: allScreensPaths.myAccount,
    name: screenNames.myAccount
  }
};

export const routes = {
  ...generalRoutes
};
